import React, { useEffect } from 'react'
import { getRealBalance } from '../signIn/cl_SignInSlice';
import { useDispatch } from 'react-redux';

function DepositWithdrawSuccessMsg (props) {
const dispatch = useDispatch();
  useEffect(()=>{
   // dispatch(getRealBalance());
  },[])
  return (
    <React.Fragment>
      <div className='SB-content'>
        <div className='SB-msgBox SB-success'>
          <div className='SB-msgBox-container'>
            <iframe src='https://lottie.host/embed/e9255bf4-e53b-4667-8025-59d2045d704e/vgc5wxHHuj.json' title='Success Animation'></iframe>
            {props.message === 'deposit' ? (
              <>
                <div className='SB-depositwithdraw-successMsg'>
                  You have successfully placed the deposit request
                </div>
                {/* <button className='btn SB-btnHome active' onClick={() => window.location.href='/'}>
                  Back to Home
                </button> */}
              </>
            ) : (
              <>
                <div className='SB-depositwithdraw-successMsg'>
                  You have successfully placed the withdraw request 
                </div>
                {/* <button className='btn SB-btnHome active' onClick={() => window.location.href='/'}>
                  Back to Home
                </button> */}
              </>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default DepositWithdrawSuccessMsg